import { useMediaQuery } from "@react-hook/media-query";
export const onIsMobileChanged = "(max-width:480px)";
export const onIsPortraitChanged = "(orientation:portrait)";
export const useMobile = () => {
    return useMediaQuery(onIsMobileChanged);
};
export const isMobile = () => {
    return window.matchMedia(onIsMobileChanged).matches;
};
export const isPortrait = () => {
    return window.matchMedia(onIsPortraitChanged).matches;
};
